import { useEffect, useRef, useState } from "react"
import { getUser } from "../../services/dashboard";
import { useNavigate, useParams } from "react-router-dom";
import { Results } from "./Results";
import { Statements } from "./Statements";
import { Forms } from "./Forms";
import { Header } from "./Header";
import { useSelector } from "react-redux";
import { BackToTop } from "../Buttons/BackToTop";

export const User = () => {
    const ref = useRef(null)
    const params = useParams();
    const navigate = useNavigate();
    const [metaInformation, setInformation] = useState({});
    const [forms, setForms] = useState(null);
    const [statements, setStatements] = useState({});
    const [results, setResults] = useState(null);
    const [isUserOpen, setIsUserOpen] = useState(true);

    const user = useSelector(state => {
        return state.user;
    });

    const handleClick = () => {
        ref.current.scrollIntoView({ behavior: "smooth" });
    }

    useEffect(() => {
        getUser(parseInt(params.id)).then(response => {
            const data = response.data;
            setInformation(data.meta);
            setForms(data.forms);
            setStatements(data.statements);
            setResults(data.results)
        }).catch(err => {
            const status = err.response.status;
            if (status === 403) {
                navigate("/login");
            }
        })
    }, [navigate, params.id]);

    return (
        <div className="flex flex-col user text-[black] w-full" ref={ref}>
            <BackToTop onClick={handleClick} />
            {/* {forms && statements && (
                <Header
                    user={user}
                    metaInformation={metaInformation}
                    forms={forms}
                    statements={statements}
                />
            )} */}
            <section className="p-8 users flex flex-col gap-3" id="user">
                <div className="flex justify-between border-b border-dashed">
                    <h2 className="text-3xl">User Information</h2>
                    <button onClick={() => setIsUserOpen(!isUserOpen)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="12.828" viewBox="0 0 22.828 12.828">
                            <g transform="translate(-639.185 -729.386)">
                                <line x1="10" y2="10" transform="translate(650.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                    strokeWidth="2" />
                                <line x2="10" y2="10" transform="translate(640.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                    strokeWidth="2" />
                            </g>
                        </svg>
                    </button>
                </div>
                {isUserOpen && (
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Created At</th>
                                <th scope="col">Updated At</th>
                                <th scope="col">Completed</th>
                                <th scope="col">Paid</th>
                                <th scope="col">Name</th>
                                <th scope="col">Surname</th>
                                <th scope="col">Email</th>
                                <th scope="col">Website</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{metaInformation.id}</td>
                                <td>{metaInformation.createdAt}</td>
                                <td>{metaInformation.updatedAt}</td>
                                <td>{metaInformation.completed === 1 ? "true" : "false"}</td>
                                <td>{metaInformation.paid === 1 ? "true" : "false"}</td>
                                <td>{metaInformation.name}</td>
                                <td>{metaInformation.surname}</td>
                                <td>{metaInformation.email}</td>
                                <td>{metaInformation.website}</td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </section>
            {forms && (<Forms forms={forms} />)}
            <Statements statements={statements} />
            {results && (
                <Results results={results} />
            )} 
        </div>
    )
}